<template>
  <div class="table-responsive mt-3 mb-0">
    <div class="container-div" @click.right="showAddMenu($event)">
      <!-- Calendar -->
      <div class="d-flex">
        <div class="time-div">12am</div>
        <div class="content-div"></div>
      </div>
      <div class="d-flex">
        <div class="time-div">1am</div>
        <div class="content-div"></div>
      </div>
      <div class="d-flex">
        <div class="time-div">2am</div>
        <div class="content-div"></div>
      </div>
      <div class="d-flex">
        <div class="time-div">3am</div>
        <div class="content-div"></div>
      </div>
      <div class="d-flex">
        <div class="time-div">4am</div>
        <div class="content-div"></div>
      </div>
      <div class="d-flex">
        <div class="time-div">5am</div>
        <div class="content-div"></div>
      </div>
      <div class="d-flex">
        <div class="time-div">6am</div>
        <div class="content-div"></div>
      </div>
      <div class="d-flex">
        <div class="time-div">7am</div>
        <div class="content-div"></div>
      </div>
      <div class="d-flex">
        <div class="time-div">8am</div>
        <div class="content-div"></div>
      </div>
      <div class="d-flex">
        <div class="time-div">9am</div>
        <div class="content-div"></div>
      </div>
      <div class="d-flex">
        <div class="time-div">10am</div>
        <div class="content-div"></div>
      </div>
      <div class="d-flex">
        <div class="time-div">11am</div>
        <div class="content-div"></div>
      </div>
      <div class="d-flex">
        <div class="time-div">12pm</div>
        <div class="content-div"></div>
      </div>
      <div class="d-flex">
        <div class="time-div">1pm</div>
        <div class="content-div"></div>
      </div>
      <div class="d-flex">
        <div class="time-div">2pm</div>
        <div class="content-div"></div>
      </div>
      <div class="d-flex">
        <div class="time-div">3pm</div>
        <div class="content-div"></div>
      </div>
      <div class="d-flex">
        <div class="time-div">4pm</div>
        <div class="content-div"></div>
      </div>
      <div class="d-flex">
        <div class="time-div">5pm</div>
        <div class="content-div"></div>
      </div>
      <div class="d-flex">
        <div class="time-div">6pm</div>
        <div class="content-div"></div>
      </div>
      <div class="d-flex">
        <div class="time-div">7pm</div>
        <div class="content-div"></div>
      </div>
      <div class="d-flex">
        <div class="time-div">8pm</div>
        <div class="content-div"></div>
      </div>
      <div class="d-flex">
        <div class="time-div">9pm</div>
        <div class="content-div"></div>
      </div>
      <div class="d-flex">
        <div class="time-div">10pm</div>
        <div class="content-div"></div>
      </div>
      <div class="d-flex">
        <div class="time-div">11pm</div>
        <div class="content-div"></div>
      </div>
      <!-- /Calendar -->

      <!-- Classes -->
      <div
        v-for="(rec, i) in classes"
        :key="i"
        :id="`event${rec.ClassId}`"
        class="event-div border-gray"
        :style="`background-color:${rec.Color}`"
        @click="showEvent(rec, $event)"
      >
        <template v-if="!rec.IsPublicHoliday">
          <span class="time-span">{{ rec.ClassTime }}</span>
          <br />
        </template>
        <template v-if="!rec.IsPublicHoliday && isMainAdmin">
          <span>{{ rec.School }}</span>
          <br />
        </template>
        <span class="event-span">{{ rec.EventName }}</span>
        <span v-if="!rec.IsPublicHoliday">({{ rec.Duration }})</span>
      </div>
      <!-- /Classes -->

      <!-- Add Menu Right Click -->
      <div
        tabindex="-1"
        class="card m-0 menu"
        id="addMenu"
        ref="addMenu"
        :style="`top:${top};left:${left};display:none`"
        @blur="closeAddMenu"
      >
        <div class="card-body p-0">
          <div @click="newClassBooking" class="menu-item">
            <i class="fa fa-plus-circle mr-1"></i>New Class Booking
          </div>
        </div>
      </div>
      <!-- /Add Menu Right Click -->
    </div>
  </div>
</template>
  
  <script>
import API from "../../../http-common.js";
import config from "../../../config.js";
import $ from "jquery";
export default {
  props: [
    "selectedDate",
    "selectedCountries",
    "schoolId",
    "subjectName",
    "subjectLevelName",
    "duration",
    "makeupClass",
    "studentName",
    "instructorName",
    "startDate",
    "endDate",
    "statuses",
    "instructorId",
    "studentId",
    "startTimeHour",
    "startTimeMinute",
    "startTimePart",
    "endTimeHour",
    "endTimeMinute",
    "endTimePart",
  ],
  data() {
    return {
      userTypeMainAdmin: config.USERTYPE_MAIN_ADMIN,
      userTypeSchoolAdmin: config.USERTYPE_SCHOOL_ADMIN,
      userTypeInstructor: config.USERTYPE_INSTRUCTOR,
      userTypeInstructorSchoolAdmin:
        config.USERTYPE_INSTRUCTOR_AND_SCHOOL_ADMIN,
      userTypeStudent: config.USERTYPE_STUDENT,
      classes: [],
      //for right click menu
      top: "0px",
      left: "0px",
      scrollTop: 0,
    };
  },
  watch: {
    "$store.state.expandSidebar": function (val) {
      window.setTimeout(() => {
        this.loadCalendar(this.classes);
      }, 300);
    },
  },
  computed: {
    tokenObj() {
      let data = JSON.parse(localStorage.getItem("cbstoken"));
      return data;
    },
    isMainAdmin() {
      return this.tokenObj.UserType == this.userTypeMainAdmin;
    },
    isSchoolAdmin() {
      return (
        this.tokenObj.UserType == this.userTypeSchoolAdmin ||
        (this.tokenObj.UserType == this.userTypeInstructorSchoolAdmin &&
          this.$route.path.includes("/schooladmin/"))
      );
    },
    isInstructor() {
      return (
        (this.tokenObj.UserType == this.userTypeInstructorSchoolAdmin ||
          this.tokenObj.UserType == this.userTypeInstructor) &&
        this.$route.path.includes("/instructor/") &&
        !this.$route.path.includes("/schooladmin/")
      );
    },
  },
  methods: {
    showEvent(payload, event) {
      event.preventDefault();
      event.cancelBubble = true;
      if (event.stopPropagation) event.stopPropagation();
      if (payload.IsPublicHoliday) {
        let obj = {
          eventName: payload.EventName,
          date: payload.DateDisplay,
          country: payload.Country,
        };
        this.$emit("showPublicHoliday", obj);
      } else {
        let obj = {
          classBookingId: payload.ClassId,
          eventName: payload.EventName,
          duration: payload.Duration,
          school: payload.School,
          student: payload.Student,
          instructor: payload.Instructor,
          date: payload.DateDisplay,
          dateCal: payload.DateCal,
          time: payload.ClassTime,
          makeupClass: payload.MakeupClass,
          location: payload.Location,
          fee: payload.ClassFee,
          status: payload.Status,
          color: payload.Color,
          canChangeToPending: payload.CanChangeToPending,
        };
        this.$emit("showClass", obj);
      }
    },
    updateCalendar() {
      window.setTimeout(() => {
        if (this.classes && this.classes.length) {
          this.loadCalendar(this.classes);
        }
      }, 300);
    },
    updateScrollTop() {
      this.scrollTop = window.scrollY || document.documentElement.scrollTop;
    },
    //right click menu add
    showAddMenu(event) {
      event.preventDefault();
      if (this.isMainAdmin || this.isSchoolAdmin || this.isInstructor) {
        this.$nextTick(() => {
          $(document).scrollTop(this.scrollTop);
        });
        $("#addMenu").show();
        this.$refs.addMenu.focus();
        let calDivOuterHeight = $(".cal-div").outerHeight();
        let calDivOuterWidth = $(".cal-div").outerWidth();
        if (calDivOuterHeight >= 300) {
          calDivOuterHeight = 0;
        } else {
          calDivOuterHeight = calDivOuterHeight + 20;
          calDivOuterWidth = 0;
        }

        let headerHeight = $(".header").outerHeight();
        let contentPaddingTop = 30;
        let pageHeaderHeight = $(".page-header").outerHeight();
        let pageHeaderMarginBottom = 30;
        let rowFilter1Height = $(".row-filter-1").length
          ? $(".row-filter-1").outerHeight()
          : 0;
        let rowFilter2Height = $(".row-filter-2").length
          ? $(".row-filter-2").outerHeight()
          : 0;
        let rowFilter3Height = $(".row-filter-3").length
          ? $(".row-filter-3").outerHeight()
          : 0;
        let rowFilter4Height = $(".row-filter-4").length
          ? $(".row-filter-4").outerHeight()
          : 0;
        let rowFilter5Height = $(".row-filter-5").length
          ? $(".row-filter-5").outerHeight()
          : 0;
        let extraMargin = !this.isMainAdmin ? 15 : 0;
        let navigationDivHeight = $(".navigation-div").outerHeight();
        let allAboveElementsHeight =
          headerHeight +
          contentPaddingTop +
          pageHeaderHeight +
          pageHeaderMarginBottom +
          rowFilter1Height +
          rowFilter2Height +
          rowFilter3Height +
          rowFilter4Height +
          rowFilter5Height +
          8 +
          20 +
          navigationDivHeight +
          16 +
          calDivOuterHeight +
          extraMargin;
        let top = event.y + this.scrollTop - allAboveElementsHeight;

        let sideBarOuterWidth = $(".sidebar").outerWidth();
        let allLeftElementsWidth = sideBarOuterWidth + 30 + calDivOuterWidth;
        let addMenuOuterWidth = $(".menu").outerWidth();
        let timeDivOuterWidth = $(".time-div").outerWidth();
        let contentDivOuterWidth = $(".content-div").outerWidth();
        let left = event.x - allLeftElementsWidth;
        if (
          left >=
          timeDivOuterWidth + contentDivOuterWidth - addMenuOuterWidth
        ) {
          left = left - (addMenuOuterWidth + 5);
        }
        this.top = top + "px";
        this.left = left + "px";
      }
    },
    closeAddMenu() {
      $("#addMenu").hide();
    },
    newClassBooking() {
      let routerName = "";
      if (this.isMainAdmin) routerName = "mainAdminClassBookingAdd";
      else if (this.isSchoolAdmin) routerName = "schoolAdminClassBookingAdd";
      else if (this.isInstructor) routerName = "instructorClassBookingAdd";
      this.$router.push({ name: routerName });
    },
    //main function
    getClassBookingListByDay() {
      let param = {
        Token: this.tokenObj.Token,
        Date: this.selectedDate,
        SelectedCountries: this.selectedCountries,
        SchoolId: this.schoolId,
        SubjectName: this.subjectName,
        SubjectLevelName: this.subjectLevelName,
        Duration: this.duration,
        MakeupClass: this.makeupClass,
        StudentName: this.studentName,
        InstructorName: this.instructorName,
        StartDate: this.startDate,
        EndDate: this.endDate,
        Statuses: this.statuses,
        InstructorId: this.instructorId,
        StudentId: this.studentId,
        StartTimeHour: this.startTimeHour,
        StartTimeMinute: this.startTimeMinute,
        StartTimePart: this.startTimePart,
        EndTimeHour: this.endTimeHour,
        EndTimeMinute: this.endTimeMinute,
        EndTimePart: this.endTimePart,
      };
      this.$store.state.isLoading = true;
      API.classBooking
        .getClassBookingListByDay(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.classes = response.data.data;
            this.loadCalendar(this.classes);
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          console.log(error);
        });
    },
    loadCalendar(classes) {
      if (!classes || !classes.length) return;
      //adjust width and left
      let contentDivOuterWidth = $(".content-div").outerWidth();
      let alreadyCheckedIndex = [];
      for (let i = 0; i < classes.length; i++) {
        if (alreadyCheckedIndex.includes(i)) continue;
        let minTotalStartTimeMinutes = classes[i].TotalStartTimeMinutes;
        let maxTotalEndTimeMinutes = classes[i].TotalEndTimeMinutes;
        let overlapEvents = [];
        overlapEvents.push(classes[i]);
        alreadyCheckedIndex.push(i);
        for (let j = 0; j < classes.length; j++) {
          if (i == j || alreadyCheckedIndex.includes(j)) continue;
          let totalStartTimeMinutes = classes[j].TotalStartTimeMinutes;
          let totalEndTimeMinutes = classes[j].TotalEndTimeMinutes;
          if (
            totalStartTimeMinutes >= minTotalStartTimeMinutes &&
            totalStartTimeMinutes < maxTotalEndTimeMinutes
          ) {
            overlapEvents.push(classes[j]);
            alreadyCheckedIndex.push(j);
            if (totalEndTimeMinutes > maxTotalEndTimeMinutes) {
              maxTotalEndTimeMinutes = totalEndTimeMinutes;
            }
          }
        }

        if (!overlapEvents.length) continue;
        let timeDivOuterWidth = $(".time-div").outerWidth();
        let eachElemWidth = contentDivOuterWidth / overlapEvents.length;
        this.$nextTick(() => {
          for (let x = 0; x < overlapEvents.length; x++) {
            let left = timeDivOuterWidth + x * eachElemWidth;
            $(`#event${overlapEvents[x].ClassId}`).outerWidth(
              `${eachElemWidth}px`
            );
            $(`#event${overlapEvents[x].ClassId}`).css("left", `${left}px`);
          }
        });
      }
      //adjust height and top
      this.$nextTick(() => {
        for (let item of classes) {
          let duration = item.TotalEndTimeMinutes - item.TotalStartTimeMinutes;
          $(`#event${item.ClassId}`).outerHeight(`${duration}px`);
          $(`#event${item.ClassId}`).css(
            "top",
            `${item.TotalStartTimeMinutes}px`
          );
        }
      });
    },
  },
  created() {
    this.getClassBookingListByDay();
  },
  mounted() {
    this.updateScrollTop();
    window.addEventListener("scroll", this.updateScrollTop);
    window.addEventListener("resize", this.updateCalendar);
    //scroll to next available event
    window.setTimeout(() => {
      if (this.classes && this.classes.length) {
        this.$nextTick(() => {
          if ($(`#event${this.classes[0].ClassId}`).length)
            $(document).scrollTop(
              $(`#event${this.classes[0].ClassId}`).position().top
            );
        });
      }
    }, 300);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.updateScrollTop);
    window.removeEventListener("resize", this.updateCalendar);
  },
};
</script>
  
  <style scoped>
.container-div {
  position: relative;
  cursor: pointer;
}
.time-div {
  color: #495057;
  background-color: #e9ecef;
  border-color: lightgray;
  width: 60px;
  vertical-align: top;
  padding-top: 1px;
  padding-right: 3px;
  text-align: right;
  height: 60px;
  border: 1px solid #dee2e6;
}
.content-div {
  height: 60px;
  padding: 0;
  border-bottom: 1px solid #dee2e6;
  border-right: 1px solid #dee2e6;
  width: 100%;
}
.container-div div:nth-child(1) .content-div {
  border-top: 1px solid #dee2e6 !important;
}
.event-div {
  position: absolute;
  color: white;
  padding: 3px 5px 3px 5px;
  line-height: 15px;
  font-size: 12px;
  overflow: auto;
}
.time-span {
  letter-spacing: -0.5px;
}
.menu {
  max-width: fit-content;
  border: 1px solid lightgrey;
  background: #fafafa;
  display: block;
  position: absolute;
  z-index: 99;
  font-size: 11px;
}
.menu-item {
  padding-left: 5px;
  padding-right: 5px;
  padding-top: 1px;
  cursor: pointer;
}
.menu-item:hover {
  background: #d0d0d0;
}
.border-gray {
  border: 1px solid #dee2e6;
}
</style>


// WEBPACK FOOTER //
// src/components/SchoolUser/SchoolAdmin/ClassBookingCalendarFormatDay.vue